import { Box, Checkbox, Chip, FormControlLabel, Typography } from "@mui/material";


function GradesClassroomsSelect({ classroomOptions, classroomsState, setClassroomsState }) {

    const handleGradeCheckBoxes = (g) => (event) => {
        const newClassroomsState = [...classroomsState];
        const classroomsToCheck = newClassroomsState
            .filter(i => i.gradeUid === g.uid);
        classroomsToCheck.forEach(o => { o.checked = event.target.checked });
        setClassroomsState(newClassroomsState);
    }

    const toggleClassroom = (c) => {
        const newClassroomsState = [...classroomsState];
        const classroomToCheck = newClassroomsState.find(i => (i.uid === c.uid));
        classroomToCheck.checked = !classroomToCheck.checked;
        setClassroomsState(newClassroomsState);
    }


    return classroomOptions.length > 0 && (<Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Classes</Typography>
        {classroomOptions.filter(g => g.choices.length > 0).map(g => (
            <Box key={g.uid} sx={{ mb: 1.5 }}>
                <FormControlLabel
                    control={
                        < Checkbox
                            checked={classroomsState.filter(c => c.gradeUid === g.uid).every(i => i.checked)}
                            onChange={handleGradeCheckBoxes(g)}
                            name={g.name}
                            value={g.uid}
                            color="primary"
                        />
                    }
                    label={<Typography sx={{ fontWeight: 'bold' }}>{g.name}</Typography>}
                />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, pl: 4.5 }}>
                    {[...g.choices].sort((a, b) => a.name.localeCompare(b.name, 'fr', { numeric: true, sensitivity: 'base' })).map(c => {
                        const isChecked = Boolean(classroomsState.find(i => i.uid === c.uid)?.checked);
                        return (
                            <Chip
                                key={c.uid}
                                label={c.name}
                                size="small"
                                clickable
                                onClick={() => toggleClassroom(c)}
                                color={isChecked ? "secondary" : "default"}
                                variant={isChecked ? "filled" : "outlined"}
                            />
                        );
                    })}
                </Box>
            </Box>
        ))}
    </Box>)
}

export default GradesClassroomsSelect;
